const asyncComponentFactory = (handle) => {
  return (node, ctx) => {
    return import(
      /* webpackChunkName: "[request]" */
      /* webpackMode: "lazy" */
      `./components/${handle}`
    ).then((module) => {
      if (typeof module.default === 'function') {
        const instance = module.default(node, ctx);
        const unsubscribe = ctx.on('unmount', () => {
          instance.unmount();
          unsubscribe();
        });
      }
    });
  };
};


// COMMON UI ==================================================================
import Drawer from "./components/ui/Drawer";
import MiniCart from "./components/cart/MiniCart.jsx";
import QuickSearch from "./components/ui/QuickSearch";

// NAV UI Components ==========================================================
import MainNav from "./components/nav/MainNav";
import MobileNav from "./components/nav/MobileNav";
import FooterNav from "./components/nav/FooterNav";

// MEDIA Components ===========================================================

// PRODUCT ====================================================================

// CONTENT ====================================================================

const AppComponents = {
  // UI ==================================================================
  Drawer,
  MiniCart,
  QuickSearch,
  AnnouncementBar: asyncComponentFactory('ui/AnnouncementBar.js'),
  Accordion: asyncComponentFactory('ui/Accordion.js'),
  Dropdown: asyncComponentFactory('ui/Dropdown.js'),
  Countdown: asyncComponentFactory('ui/Countdown.js'),
  HomeHero: asyncComponentFactory('ui/HomeHero.js'),
  HeroVideo: asyncComponentFactory('ui/HeroVideo.js'),
  FabricsInfoSlider: asyncComponentFactory('ui/FabricsInfoSlider.js'),
  Slider: asyncComponentFactory('ui/Slider.js'),
  SliderV2: asyncComponentFactory('ui/SliderV2.js'),
  RLSAReviewsFilter: asyncComponentFactory('ui/RLSAReviewsFilter.js'),
  Modal: asyncComponentFactory('ui/Modal.js'),
  NewDrops: asyncComponentFactory('ui/NewDrops.js'),
  Tabs: asyncComponentFactory('ui/Tabs.js'),
  BundleBuilder: asyncComponentFactory('ui/BundleBuilder'),
  SwiperSlider: asyncComponentFactory('ui/SwiperSlider'),
  ScrollingElements: asyncComponentFactory('ui/ScrollingElements'),

  // NAV UI ===================================================================
  MainNav,
  MobileNav,
  FooterNav,
  CollectionFilters: asyncComponentFactory('nav/CollectionFilters.js'),
  AccordionNav: asyncComponentFactory('nav/AccordionNav.js'),
  CollectionSort: asyncComponentFactory('nav/CollectionSort.js'),
  LazyLoader: asyncComponentFactory('nav/LazyLoader.js'),
  Quicknav: asyncComponentFactory('nav/Quicknav.js'),
  StickyBar: asyncComponentFactory('nav/StickyBar.js'),

  // MEDIA ===================================================================
  MediaPlayer: asyncComponentFactory('media/MediaPlayer'),
  VideoCover: asyncComponentFactory('media/VideoCover.jsx'),
  VideoBanner: asyncComponentFactory('media/VideoBanner'),
  VideoSlider: asyncComponentFactory('media/VideoSlider'),
  VideoCard: asyncComponentFactory('media/VideoCard'),

  // PRODUCT ==================================================================
  ProductForm: asyncComponentFactory('product/ProductForm'),
  CrossSell: asyncComponentFactory('product/CrossSell'),
  ProductGallery: asyncComponentFactory('product/ProductGallery'),
  SlickProductGallery: asyncComponentFactory('product/SlickProductGallery'),
  ProductVideoPlayer: asyncComponentFactory('product/ProductVideoPlayer'),

  // CONTENT ==================================================================
  CostBreakdown: asyncComponentFactory('content/CostBreakdown'),
  FabricsSelector: asyncComponentFactory('content/FabricsSelector'),
  FabricsSelectorTiles: asyncComponentFactory('content/FabricsSelectorTiles'),
  Quiz: asyncComponentFactory('content/Quiz'),

  FreeShipping: asyncComponentFactory('cart/FreeShipping.js'),
  HandwrittenNote: asyncComponentFactory('cart/HandwrittenNote'),
  //ProgressBar: asyncComponentFactory('checkout/ProgressBar'),
};

export default AppComponents;